import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumbs = ({ items = [] }) => {
  const location = useLocation();

  const routeLabels = {
    '/quote-calculator': 'Quote Calculator',
    '/quote-management': 'Quote Management',
    '/client-database': 'Client Database',
    '/digital-quote-review': 'Digital Quote Review',
    '/administrative-settings': 'Administrative Settings',
  };

  const generateBreadcrumbs = () => {
    if (items?.length > 0) {
      return items;
    }

    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [{ label: 'Home', path: '/quote-calculator' }];

    if (pathSegments?.length > 0) {
      const currentPath = `/${pathSegments?.join('/')}`;
      const label = routeLabels?.[currentPath] || pathSegments?.[pathSegments?.length - 1];
      
      if (currentPath !== '/quote-calculator') {
        breadcrumbs?.push({ label, path: currentPath });
      }
    }

    return breadcrumbs;
  };

  const breadcrumbItems = generateBreadcrumbs();

  if (breadcrumbItems?.length <= 1) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm text-text-secondary mb-6" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {breadcrumbItems?.map((item, index) => (
          <li key={item?.path} className="flex items-center space-x-2">
            {index > 0 && (
              <Icon name="ChevronRight" size={14} className="text-text-secondary" />
            )}
            {index === breadcrumbItems?.length - 1 ? (
              <span className="font-medium text-text-primary" aria-current="page">
                {item?.label}
              </span>
            ) : (
              <Link
                to={item?.path}
                className="hover:text-text-primary transition-smooth"
              >
                {item?.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;